
import { useMsal } from '@azure/msal-react';
import { Button } from '@mui/material';
import { FormattedMessage } from "react-intl";
import { persistor } from '../../store';
import { styles } from '../../style/style';

export default function LogoutButton() {

    const { instance } = useMsal();
    const accountId = localStorage.getItem("homeAccountId");

    async function logoutUser() {
        // Use the existing initialized instance instead of creating a new one
        const account = instance.getAccountByHomeId(accountId);

        // you can select which account application should sign out
        const logoutRequest = {
            account: account,
        };
        
        persistor.purge();
        await instance.logoutRedirect(logoutRequest);
    }

    return (
        <Button id="logoutButton" sx={styles.LogoutButton} onClick={logoutUser}><FormattedMessage id='user.logout' defaultMessage='Logout' /></Button>
    )
}
